import React from 'react';
import './App.css';
import SubscriptionForm from './components/SubscriptionForm';

function App() {
  return (
    <div className="App">
      <div style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        minHeight: '100vh',
        padding: '40px 20px',
        color: 'white',
        fontFamily: 'Inter, Arial, sans-serif'
      }}>
        {/* Hero Section */}
        <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto 60px' }}>
          <h1 style={{ 
            fontSize: '3.5rem', 
            fontWeight: 'bold', 
            marginBottom: '20px',
            lineHeight: '1.2'
          }}>
            AI 최전선의 진짜 트렌드<br/>
            <span style={{ color: '#4fc3f7' }}>5분 핵심 요약</span>
          </h1>
          
          <p style={{ 
            fontSize: '1.3rem', 
            marginBottom: '40px',
            opacity: '0.9'
          }}>
            글로벌 AI 커뮤니티의 최신 인사이트를<br/>
            매주 요약 전달합니다
          </p>

          <SubscriptionForm />
        </div>

        {/* Problem Section */}
        <div style={{ 
          backgroundColor: 'rgba(255,255,255,0.1)', 
          padding: '40px', 
          borderRadius: '16px',
          marginBottom: '40px',
          backdropFilter: 'blur(10px)'
        }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            textAlign: 'center', 
            marginBottom: '40px',
            fontWeight: 'bold'
          }}>
            AI 정보, 이래서 놓칩니다
          </h2>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
            gap: '30px' 
          }}>
            {[
              { icon: '⏰', title: '시간 낭비', desc: '30분 영상, 핵심은 2분' },
              { icon: '🔄', title: '알고리즘 함정', desc: '늘 비슷한 추천 콘텐츠' },
              { icon: '⚡', title: '뒤늦은 발견', desc: '이미 대세가 바뀌었다고?' },
              { icon: '🌐', title: '언어 장벽', desc: '국외 커뮤니티는 영어라...' }
            ].map((item, index) => (
              <div key={index} style={{ 
                backgroundColor: 'rgba(255,255,255,0.15)', 
                padding: '30px', 
                borderRadius: '12px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '3rem', marginBottom: '15px' }}>{item.icon}</div>
                <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', fontWeight: 'bold' }}>
                  {item.title}
                </h3>
                <p style={{ opacity: '0.9' }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Solution Section */}
        <div style={{ 
          backgroundColor: 'rgba(255,255,255,0.1)', 
          padding: '40px', 
          borderRadius: '16px',
          marginBottom: '40px',
          backdropFilter: 'blur(10px)'
        }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            textAlign: 'center', 
            marginBottom: '20px',
            fontWeight: 'bold'
          }}>
            매주 AI 트렌드 추적<br/>
            <span style={{ color: '#4fc3f7' }}>핵심 요약</span>
          </h2>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '30px',
            marginTop: '40px'
          }}>
            <div style={{ 
              backgroundColor: 'rgba(76, 175, 80, 0.2)', 
              padding: '30px', 
              borderRadius: '12px'
            }}>
              <h3 style={{ fontSize: '1.5rem', marginBottom: '20px', fontWeight: 'bold' }}>
                글로벌 모니터링
              </h3>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '10px' }}>• 국내외 유명 커뮤니티</li>
                <li>• 국내외 유명 IT 리더</li>
              </ul>
            </div>
            
            <div style={{ 
              backgroundColor: 'rgba(33, 150, 243, 0.2)', 
              padding: '30px', 
              borderRadius: '12px'
            }}>
              <h3 style={{ fontSize: '1.5rem', marginBottom: '20px', fontWeight: 'bold' }}>
                5분 완독
              </h3>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '10px' }}>• 핵심 요약</li>
                <li>• 트렌드 의견 추가</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Credibility Section - 섹션 4 */}
        <div style={{ 
          backgroundColor: 'rgba(255,255,255,0.1)', 
          padding: '40px', 
          borderRadius: '16px',
          marginBottom: '40px',
          backdropFilter: 'blur(10px)'
        }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            textAlign: 'center', 
            marginBottom: '40px',
            fontWeight: 'bold'
          }}>
            매주 이만큼 분석합니다
          </h2>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '30px' 
          }}>
            {[
              { number: '10,000+', desc: '글로벌 게시물 스캔' },
              { number: '15개', desc: '해외 커뮤니티 분석' },
              { number: '100+', desc: '자체 분석 정교화 기능' }
            ].map((item, index) => (
              <div key={index} style={{ 
                textAlign: 'center',
                backgroundColor: 'rgba(255,255,255,0.15)', 
                padding: '40px 20px', 
                borderRadius: '12px'
              }}>
                <div style={{ 
                  fontSize: '3rem', 
                  fontWeight: 'bold', 
                  color: '#4fc3f7',
                  marginBottom: '15px'
                }}>
                  {item.number}
                </div>
                <p style={{ fontSize: '1.1rem', opacity: '0.9' }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Urgency Section - 섹션 5 */}
        <div style={{ 
          backgroundColor: 'rgba(244, 67, 54, 0.15)', 
          padding: '40px', 
          borderRadius: '16px',
          marginBottom: '40px',
          backdropFilter: 'blur(10px)',
          border: '2px solid rgba(244, 67, 54, 0.3)'
        }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            textAlign: 'center', 
            marginBottom: '30px',
            fontWeight: 'bold',
            color: '#ffcdd2'
          }}>
            한정 무료 공개
          </h2>
          
          <div style={{ 
            textAlign: 'center', 
            fontSize: '1.2rem', 
            lineHeight: '1.8',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            <p style={{ marginBottom: '20px' }}>
              광고 없이 오직 입소문으로만<br/>
              이 페이지를 다시 찾기는 어렵습니다
            </p>
            <p style={{ marginBottom: '20px' }}>
              AI 시스템 운영 비용으로<br/>
              무료 구독은 선착순 제한됩니다
            </p>
            <p style={{ 
              fontSize: '1.4rem', 
              fontWeight: 'bold',
              color: '#ffcdd2'
            }}>
              지금이 마지막 기회일 수 있습니다
            </p>
          </div>
        </div>

        {/* Benefits Section - 섹션 6 */}
        <div style={{ 
          backgroundColor: 'rgba(76, 175, 80, 0.15)', 
          padding: '40px', 
          borderRadius: '16px',
          marginBottom: '40px',
          backdropFilter: 'blur(10px)'
        }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            textAlign: 'center', 
            marginBottom: '40px',
            fontWeight: 'bold'
          }}>
            즉시 받는 보너스
          </h2>
          
          <div style={{ 
            backgroundColor: 'rgba(255,255,255,0.2)', 
            padding: '30px', 
            borderRadius: '12px',
            textAlign: 'center',
            maxWidth: '500px',
            margin: '0 auto'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '20px' }}>📘</div>
            <h3 style={{ 
              fontSize: '1.8rem', 
              marginBottom: '15px',
              fontWeight: 'bold',
              color: '#4fc3f7'
            }}>
              "실전 AI 툴 가이드"
            </h3>
            <p style={{ 
              fontSize: '1.1rem', 
              marginBottom: '20px',
              opacity: '0.9'
            }}>
              AI 에이전트를 위한 가이드
            </p>
            <p style={{ 
              fontSize: '1.2rem', 
              fontWeight: 'bold',
              color: '#c8e6c9'
            }}>
              가입 즉시 이메일로 전송
            </p>
          </div>
        </div>

        {/* Sign-up Section - 섹션 7 */}
        <div style={{ 
          backgroundColor: 'rgba(255,255,255,0.1)', 
          padding: '40px', 
          borderRadius: '16px',
          marginBottom: '40px',
          backdropFilter: 'blur(10px)',
          textAlign: 'center'
        }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            marginBottom: '40px',
            fontWeight: 'bold'
          }}>
            5초면 충분합니다
          </h2>
          
          <SubscriptionForm />
        </div>

        {/* FAQ Section - 섹션 8 */}
        <div style={{ 
          backgroundColor: 'rgba(255,255,255,0.1)', 
          padding: '40px', 
          borderRadius: '16px',
          marginBottom: '40px',
          backdropFilter: 'blur(10px)'
        }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            textAlign: 'center', 
            marginBottom: '40px',
            fontWeight: 'bold'
          }}>
            자주 묻는 질문
          </h2>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '20px' 
          }}>
            {[
              { q: '정말 무료인가요?', a: '네, 100% 무료입니다' },
              { q: '영상보다 효율적인가요?', a: '30분 → 3분, 10배 효율' },
              { q: '영어 몰라도 되나요?', a: '완벽한 한국어 번역 제공' },
              { q: '왜 Reddit인가요?', a: '유튜브보다 빠른 정보' }
            ].map((item, index) => (
              <div key={index} style={{ 
                backgroundColor: 'rgba(255,255,255,0.15)', 
                padding: '25px', 
                borderRadius: '12px'
              }}>
                <h3 style={{ 
                  fontSize: '1.2rem', 
                  marginBottom: '10px',
                  fontWeight: 'bold',
                  color: '#4fc3f7'
                }}>
                  Q: {item.q}
                </h3>
                <p style={{ opacity: '0.9' }}>A: {item.a}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Final CTA Section - 섹션 9 */}
        <div style={{ 
          backgroundColor: 'rgba(156, 39, 176, 0.15)', 
          padding: '50px 40px', 
          borderRadius: '16px',
          marginBottom: '40px',
          backdropFilter: 'blur(10px)',
          textAlign: 'center',
          border: '2px solid rgba(156, 39, 176, 0.3)'
        }}>
          <h2 style={{ 
            fontSize: '2.8rem', 
            marginBottom: '20px',
            fontWeight: 'bold',
            color: '#e1bee7'
          }}>
            지금이 마지막 기회
          </h2>
          
          <p style={{ 
            fontSize: '1.4rem', 
            marginBottom: '30px',
            fontWeight: 'bold'
          }}>
            매주 진짜 AI 트렌드를 받아보세요
          </p>
          
          <div style={{ 
            marginBottom: '40px',
            fontSize: '1.1rem',
            lineHeight: '1.8'
          }}>
            <p style={{ marginBottom: '10px' }}>• 무료 구독</p>
            <p style={{ marginBottom: '10px' }}>• 즉시 취소 가능</p>
            <p>• 30분 → 3분 요약</p>
          </div>
          
          <SubscriptionForm />
        </div>

        {/* Footer - 섹션 10 */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '80px', 
          paddingTop: '40px',
          borderTop: '1px solid rgba(255,255,255,0.3)',
          opacity: '0.8'
        }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '30px', 
            marginBottom: '20px',
            flexWrap: 'wrap'
          }}>
            <a href="/terms" style={{ 
              color: 'rgba(255,255,255,0.8)', 
              textDecoration: 'none',
              fontSize: '14px',
              transition: 'color 0.3s ease'
            }}>
              이용약관
            </a>
            <a href="/privacy" style={{ 
              color: 'rgba(255,255,255,0.8)', 
              textDecoration: 'none',
              fontSize: '14px',
              transition: 'color 0.3s ease'
            }}>
              개인정보보호
            </a>
          </div>
          <p style={{ 
            fontSize: '14px',
            margin: '0',
            color: 'rgba(255,255,255,0.6)'
          }}>
            (주) KCC
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;